import React from 'react';

const TeamPage: React.FC = () => {
    return (
        <div>
            <h1>Our Team</h1>
            <p>Welcome to the team page. Here you can find information about our team members.</p>
        </div>
    );
};

export default TeamPage;